import { render, staticRenderFns } from "./order_details.vue?vue&type=template&id=b5b0a162&scoped=true&"
import script from "./order_details.vue?vue&type=script&lang=js&"
export * from "./order_details.vue?vue&type=script&lang=js&"
import style0 from "./order_details.vue?vue&type=style&index=0&id=b5b0a162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b0a162",
  null
  
)

export default component.exports